var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "Modal",
        {
          attrs: { width: 1000, "footer-hide": true, title: "搜素" },
          model: {
            value: _vm.mainTable.sarchCardShow,
            callback: function ($$v) {
              _vm.$set(_vm.mainTable, "sarchCardShow", $$v)
            },
            expression: "mainTable.sarchCardShow",
          },
        },
        [
          _c("search-card", {
            attrs: {
              form: _vm.mainTable.searchForm,
              "table-load-event": _vm.getDiscardTableRecord,
              "table-search": _vm.mainTable.tableSearch,
            },
          }),
        ],
        1
      ),
      _c(
        "Modal",
        {
          attrs: {
            width: 70,
            "footer-hide": true,
            title: "报损记录",
            "class-name": "vertical-center-modal",
          },
          on: { "on-visible-change": _vm.onShowChange },
          model: {
            value: _vm.show,
            callback: function ($$v) {
              _vm.show = $$v
            },
            expression: "show",
          },
        },
        [
          _c(
            "Card",
            { attrs: { padding: 0, bordered: false, "dis-hover": true } },
            [
              _c(
                "Row",
                { attrs: { gutter: 16 } },
                [
                  _c("Col", { attrs: { span: "24" } }, [
                    _c("div", { staticClass: "global-tool-bar" }, [
                      _c("div", { staticClass: "left-bar" }, [
                        _c("span", { staticClass: "title" }, [
                          _vm._v("报损单列表"),
                        ]),
                      ]),
                      _c(
                        "div",
                        { staticClass: "right-bar" },
                        [
                          _vm.$checkAccessArray(["B", "C"])
                            ? _c(
                                "Button",
                                {
                                  staticClass: "btns",
                                  attrs: {
                                    size: "small",
                                    shape: "circle",
                                    type: "success",
                                    icon: "ios-add-circle-outline",
                                  },
                                  on: { click: _vm.onCreateDiscard },
                                },
                                [_vm._v("新增")]
                              )
                            : _vm._e(),
                          _c(
                            "Button",
                            {
                              staticClass: "btns",
                              attrs: {
                                type: "info",
                                size: "small",
                                shape: "circle",
                                icon: "ios-send",
                                loading: _vm.btnLoading,
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.onExport()
                                },
                              },
                            },
                            [_vm._v("导出")]
                          ),
                          _c(
                            "Button",
                            {
                              staticClass: "btns",
                              attrs: {
                                type: "primary",
                                size: "small",
                                shape: "circle",
                                icon: "ios-search",
                              },
                              on: {
                                click: function ($event) {
                                  _vm.mainTable.sarchCardShow =
                                    !_vm.mainTable.sarchCardShow
                                },
                              },
                            },
                            [_vm._v("搜索")]
                          ),
                        ],
                        1
                      ),
                    ]),
                  ]),
                ],
                1
              ),
              _c(
                "Row",
                { attrs: { gutter: 16 } },
                [
                  _c(
                    "Col",
                    { attrs: { span: "24" } },
                    [
                      _c("stand-pagination-table", {
                        attrs: {
                          columns: _vm.mainTable.columns,
                          data: _vm.mainTable.data,
                          loading: _vm.mainTable.loading,
                          extHeight: 100,
                          "table-search": _vm.mainTable.tableSearch,
                          "table-load-event": _vm.getDiscardTableRecord,
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("CurSaleWarehouseDiscardEdit", {
        ref: "curSaleWarehouseDiscardEditModal",
      }),
      _c("CurSaleWarehouseDiscardDetail", {
        ref: "curSaleWarehouseDiscardDetailModal",
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }